import { render, staticRenderFns } from "./NotificationWithActions.vue?vue&type=template&id=c7dfb616&scoped=true&"
import script from "./NotificationWithActions.vue?vue&type=script&lang=js&"
export * from "./NotificationWithActions.vue?vue&type=script&lang=js&"
import style0 from "./NotificationWithActions.vue?vue&type=style&index=0&id=c7dfb616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dfb616",
  null
  
)

export default component.exports